<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Devedor - {{contribuinte.codContribuinte != null ? 'Editar' : 'Incluir'}}</h1>
        <b-card title="Dados do Devedor">
            <b-row class="mb-0">
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Tipo de Devedor:"
                            label-for="valor"
                            class="text-label required">
                        <b-form-select v-model="contribuinte.tipoContribuinte" :disabled="contribuinte.codContribuinte != null"
                                       @change="contribuinte.documento = null">
                            <option
                                    v-for="tc in dados.tipoDevedor"
                                    :key="tc.id"
                                    :value="tc">
                                {{ tc.nome ? tc.nome : 'NENHUM' }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col sm="2" md="5">
                    <b-form-group
                            label="Nome:"
                            label-for="nome"
                            class="text-label required">
                        <b-form-input v-model="contribuinte.nome" type="text" id="nome" maxlength="100"
                            @keyup="contribuinte.nome = removeSpecialCharacters(contribuinte.nome)"
                            :class="'text-label required ' + (!validations.nome.valid ? 'is-invalid' : '')"/>
                        <div v-if="!validations.nome.valid" class="invalid-message">{{validations.nome.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <p>
                        Situação:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group-9"
                                v-model="contribuinte.indAtivo"
                                name="radio-situacao" :disabled="contribuinte.codContribuinte == null">
                            <b-form-radio value="true">Ativo</b-form-radio>
                            <b-form-radio value="false">Inativo</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col sm="12" md="3">
                    <b-form-group
                            :label="contribuinte.tipoContribuinte == null || contribuinte.tipoContribuinte.id == 0 ? 'CPF:' : 'CNPJ:'"
                            label-for="cpf"
                            :class="'text-label required' + (!validations.cpf.valid ? 'is-invalid' : '')">
                        <b-form-input
                                v-if="contribuinte.tipoContribuinte == null || contribuinte.tipoContribuinte.id == 0"
                                type="text"
                                id="num-documento"
                                data-vv-as="CPF"
                                v-model="contribuinte.documento"
                                v-mask="['###.###.###-##']"
                                description="Somente os números"
                                @change="validarDocumento()"
                                :disabled="contribuinte.codContribuinte != null"
                                :class="!validations.cpf.valid ? 'is-invalid' : ''"
                        />
                        <b-form-input
                                v-if="contribuinte.tipoContribuinte != null && contribuinte.tipoContribuinte.id == 1"
                                type="text"
                                id="num-documento"
                                data-vv-as="CPF"
                                v-model="contribuinte.documento"
                                v-mask="['##.###.###/####-##']"
                                description="Somente os números"
                                @change="validarDocumento()"
                                :disabled="contribuinte.codContribuinte != null"
                                :class="!validations.cpf.valid ? 'is-invalid' : ''"
                        />
                        <div v-if="!validations.cpf.valid" class="invalid-message">{{validations.cpf.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Telefone/Celular:"
                            label-for="telefone"
                            class="text-label">
                        <b-form-input
                                type="text"
                                id="telefone"
                                data-vv-as="telefone"
                                v-model="contribuinte.telefone"
                                v-mask="['(##) #####-####', '(##) ####-####']"
                                description="Somente os números"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Telefone Alternativo 1:"
                            label-for="telefoneAlternativo1"
                            class="text-label">
                        <b-form-input
                                type="text"
                                id="telefoneAlternativo1"
                                data-vv-as="telefoneAlternativo1"
                                v-model="contribuinte.telefoneAlternativo1"
                                v-mask="['(##) #####-####', '(##) ####-####']"
                                description="Somente os números"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Telefone Alternativo 2:"
                            label-for="telefoneAlternativo2"
                            class="text-label">
                        <b-form-input
                                type="text"
                                id="telefoneAlternativo2"
                                data-vv-as="telefoneAlternativo2"
                                v-model="contribuinte.telefoneAlternativo2"
                                v-mask="['(##) #####-####', '(##) ####-####']"
                                description="Somente os números"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col sm="12" md="3">
                    <b-form-group
                            label="E-mail principal:"
                            label-for="email"
                            class="text-label">
                        <b-form-input v-model="contribuinte.email" type="text" id="email" maxlength="100" ref="email"
                                      @keyup="contribuinte.email = removeSpecialCharactersGeral(contribuinte.email)"
                                      :class="!validations.email.valid ? 'is-invalid' : ''"/>
                        <div v-if="!validations.email.valid" class="invalid-message">E-mail inválido!</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                            label="E-mail alternativo 1:"
                            label-for="emailAlternativo1"
                            class="text-label">
                        <b-form-input v-model="contribuinte.emailAlternativo1" type="text" id="emailAlternativo1" maxlength="100" ref="emailAlternativo1"
                                      @keyup="contribuinte.emailAlternativo1 = removeSpecialCharactersGeral(contribuinte.emailAlternativo1)"
                                      :class="!validations.emailAlternativo1.valid ? 'is-invalid' : ''"/>
                        <div v-if="!validations.emailAlternativo1.valid" class="invalid-message">E-mail inválido!</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                            label="E-mail alternativo 2:"
                            label-for="emailAlternativo2"
                            class="text-label">
                        <b-form-input v-model="contribuinte.emailAlternativo2" type="text" id="emailAlternativo2" maxlength="100" ref="emailAlternativo2"
                                      @keyup="contribuinte.emailAlternativo2 = removeSpecialCharactersGeral(contribuinte.emailAlternativo2)"
                                      :class="!validations.emailAlternativo2.valid ? 'is-invalid' : ''"/>
                        <div v-if="!validations.emailAlternativo2.valid" class="invalid-message">E-mail inválido!</div>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>
        <b-card title="Dados do Endereço">
            <b-row>
                <b-col sm="2" md="3">
                    <b-form-group
                            label="CEP:"
                            label-for="cep"
                            class="text-label">
                        <b-form-input
                                type="text"
                                id="cep"
                                data-vv-as="cep"
                                v-model="contribuinte.cep"
                                v-mask="['#####-###']"
                                description="Somente os números"
                                @change="obterEnderecoPorCep()"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col>
                    <b-form-group
                            label="Logradouro:"
                            label-for="logradouro"
                            class="text-label">
                        <b-form-input v-model="contribuinte.logradouro" type="text" id="logradouro" maxlength="100"
                                      @keyup="contribuinte.logradouro = removeSpecialCharactersGeral(contribuinte.logradouro)"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Número:"
                            label-for="numero"
                            class="text-label">
                        <b-form-input v-model="contribuinte.numero" type="text" id="numero" maxlength="10"
                                      @keyup="contribuinte.numero = removeSpecialCharactersGeral(contribuinte.numero)"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="7">
                    <b-form-group
                            label="Complemento:"
                            label-for="complemento"
                            class="text-label">
                        <b-form-input v-model="contribuinte.complemento" type="text" id="complemento" maxlength="50"
                                      @keyup="contribuinte.complemento = removeSpecialCharactersGeral(contribuinte.complemento)"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Bairro:"
                            label-for="bairro"
                            class="text-label">
                        <b-form-input v-model="contribuinte.bairro" type="text" id="bairro" maxlength="50"
                                      @keyup="contribuinte.bairro = removeSpecialCharactersGeral(contribuinte.bairro)"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group label="UF:" label-for="uf" class="text-label">
                        <multiselect
                                class="multiselect-simple"
                                name="uf"
                                v-model="contribuinte.uf"
                                :show-labels="false"
                                :options="dados.uf"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                :preserve-search="false"
                                placeholder="Selecione"
                                track-by="nome"
                                label="nome"
                                @input="listarMunicipios()">
                            <template v-slot:first>
                                <option :value="null">Selecionar</option>
                            </template>
                        </multiselect>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group label="Município:" label-for="municipio" class="text-label">
                        <multiselect
                                class="multiselect-simple"
                                name="municipio"
                                v-model="contribuinte.municipio"
                                :show-labels="false"
                                :options="dados.municipios"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                :preserve-search="false"
                                placeholder="Selecione"
                                track-by="codMunicipio"
                                label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
                id="modal-voltar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Voltar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="contribuinte.codContribuinte != null">Deseja retornar à tela anterior sem salvar as alterações?</p>
                    <p style="font-weight: bold;" v-if="contribuinte.codContribuinte == null">Deseja retornar à tela anterior sem salvar o cadastro?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-voltar')"> Não</b-button>
                <b-button variant="primary" @click="voltar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="contribuinte.codContribuinte != null">Deseja salvar as alterações?</p>
                    <p style="font-weight: bold;" v-if="contribuinte.codContribuinte == null">Deseja salvar o cadastro?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')"> Não</b-button>
                <b-button variant="primary" @click="salvar"> Sim</b-button>
            </template>
        </b-modal>
        <hr class="mt-2"/>
        <b-row class="center-xy">
            <b-button variant="outline-secondary" v-b-modal.modal-voltar>
                <i class="fa fa-reply"></i> Voltar
            </b-button>
            <b-button variant="primary" class="ml-2" @click="validarSalvar">
                <i class="far fa-save"></i> Salvar
            </b-button>
        </b-row>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import formatarMixins from '../../mixins/formatarMixins'
    import CompLoading from "../shared/components/CompLoading";

    export default {
        components: {CompLoading, Multiselect},
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                contribuinte: {
                    codContribuinte: null,
                    tipoContribuinte: null,
                    nome: null,
                    indAtivo: null,
                    documento: null,
                    telefone: null,
                    telefoneAlternativo1: null,
                    telefoneAlternativo2: null,
                    email: null,
                    emailAlternativo1: null,
                    emailAlternativo2: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: null,
                    municipio: null
                },
                validations: {
                    email: { valid: true, message: ""},
                    emailAlternativo1: { valid: true, message: ""},
                    emailAlternativo2: { valid: true, message: ""},
                    cpf: {valid: true, message: ''},
                    nome: { valid: true, message: ""}
                },
                dados: {
                    tipoDevedor: [],
                    uf: [],
                    municipios: []
                }
            }
        },

        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            async listarUfs() {
                axios.get(`${this.urlApi}/v1/endereco/listarUf`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.uf = response.data;
                })
            },
            async listarTipoDevedor() {
                axios.get(`${this.urlApi}/v1/contribuinte/listarTipoDevedor`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.tipoDevedor = response.data;
                    if(this.contribuinte.tipoContribuinte == null) {
                        this.contribuinte.tipoContribuinte = this.dados.tipoDevedor[0];
                    }
                })
            },
            async listarMunicipios() {
                this.contribuinte.municipio = null;
                if(this.contribuinte.uf == null) {
                    this.dados.municipios = [];
                } else {
                    axios.get(`${this.urlApi}/v1/endereco/listarMunicipios/${this.contribuinte.uf.nome}`, {
                        headers: {
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.dados.municipios = response.data;
                    })
                }
            },

            obterEnderecoPorCep() {
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/endereco/obterEnderecoPorCep/${this.contribuinte.cep}`,'', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.contribuinte.uf = null;
                    for(var i = 0; i < this.dados.uf.length; i++) {
                        if(this.dados.uf[i].nome == response.data.uf) {
                            this.contribuinte.uf = this.dados.uf[i];
                        }
                    }

                    this.listarMunicipios();

                    this.contribuinte.municipio = response.data.cidade;
                    this.contribuinte.logradouro = response.data.logradouro;
                    this.contribuinte.bairro = response.data.bairro;
                    this.contribuinte.complemento = response.data.complemento;
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },

            testeLimapr(){
                this.contribuinte.nome = this.removeSpecialCharacters(this.contribuinte.nome);
            },

            validarSalvar() {
                this.limparErroDeValidacao(this.validations.nome);
                this.validarCampoObrigatorio(this.contribuinte.nome, this.validations.nome);
                
                if(!this.validateEmail(this.contribuinte.email, this.validations.email)
                    | !this.validateEmail(this.contribuinte.emailAlternativo1, this.validations.emailAlternativo1)
                    | !this.validateEmail(this.contribuinte.emailAlternativo2, this.validations.emailAlternativo2)) {
                    return;
                }
                if(!this.validations.cpf.valid){
                     return;
                }

                this.validarCampoObrigatorio(this.contribuinte.documento, this.validations.cpf);
                
                if(this.validationsContainsError(this.validations)) {
                    return;
                }

                this.$refs['modal-salvar'].show();
            },

            salvar() {
                this.$refs['modal-salvar'].hide();
              
                if(this.contribuinte.documento.length <= 14 && !this.validarCpf(this.contribuinte.documento)) {
                    this.adicionarErroDeValidacao(this.validations.cpf, 'CPF inválido.');
                    return;
                } else if(this.contribuinte.documento.length > 14 && !this.validarCnpj(this.contribuinte.documento)) {
                    this.adicionarErroDeValidacao(this.validations.cpf, 'CNPJ inválido.');
                    return;
                }

                if(this.contribuinte.codContribuinte != null){
                    this.validarDocumento;
                }
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/contribuinte/salvar`, this.contribuinte, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data;
                    this.$store.commit("setMsgCrud", 'Operação realizada com sucesso!!!');
                    this.$router.push({path: '/devedor'});
                }).catch((error) => {
                    this.exibirErro(error);
                    this.$refs.loading.hideLoading();
                });
            },

            voltar(evt) {
                evt.preventDefault();
                this.$router.push({path: '/devedor'});
            },

            async obterDevedor(codDevedor) {
                await axios.get(`${this.urlApi}/v1/contribuinte/obter/` + codDevedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.contribuinte = {
                        ...response.data
                    };

                    if(this.contribuinte.documento.toString().length <= 11) {
                        this.contribuinte.documento = this.mascaraCpf(this.contribuinte.documento.toString());
                    } else {
                        this.contribuinte.documento = this.mascaraCnpj(this.contribuinte.documento.toString());
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            validarDocumento() {
                this.limparErroDeValidacao(this.validations.cpf);
                if(this.contribuinte.documento != null && this.contribuinte.documento.length > 0) {
                    if(this.contribuinte.documento.length <= 14 && !this.validarCpf(this.contribuinte.documento)) {
                        this.adicionarErroDeValidacao(this.validations.cpf, 'CPF inválido.');
                        return;
                    } else if(this.contribuinte.documento.length > 14 && !this.validarCnpj(this.contribuinte.documento)) {
                        this.adicionarErroDeValidacao(this.validations.cpf, 'CNPJ inválido.');
                        return;
                    }

                    let devedorBusca = {
                        documento: this.contribuinte.documento,
                        codContribuinte: this.contribuinte.codContribuinte,
                    };

                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/receitasDiversas/obterContribuinte`, devedorBusca, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if(response.data != null && response.data != "") {
                            this.adicionarErroDeValidacao(this.validations.cpf, 'CPF/CNPJ já cadastrado no sistema.');                                   
                        }
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    });
                }
            },
        },

        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let devedorEditado = this.$store.getters.getDevedor;
            if(devedorEditado) {
                this.$store.commit('setDevedor', null);
                this.obterDevedor(devedorEditado);
            } else {
                this.contribuinte.indAtivo = true;
            }

            this.listarUfs();
            this.listarTipoDevedor();
        }
    }
</script>
<style>
    .multiselect-simple .multiselect__content-wrapper .multiselect__content .multiselect__element span:before {
        display: none;
    }
</style>